export function assertUnreachable(x: never): never {
  throw new Error("Didn't expect to get here");
}

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
